const initialStateOrganisationUnit = {
  organisation_unit: [],
  update_organisation_unit: false,
};

export default initialStateOrganisationUnit;